<template>
  <div class="lke-bg">
    <div class="lke-bg-in">
      <div class="lke-in-l">
        <div class="lke-l-top">
          <div class="lke-l-top-1">
            <el-image v-if="userInfo.avatar" style="width: 88px; height: 118px; border: 1px solid #753582"
              :src="url + userInfo.avatar" fit="fill"></el-image>
            <el-image v-else style="width: 88px; height: 118px; border: 1px solid #753582"
              :src="require('@/pages/index/assets/userAvatar.png')" fit="fill"></el-image>
            <div <div class="lke-l-top-1-r">
              <p class="lke-l-top-1-r-p">欢迎您：</p>
              <el-popover placement="bottom" trigger="hover" v-model="visible">
                <div style="margin: 5px 0">
                  <div class="lke-l-top-1-r-but-in" @click="openRouter('password')">
                    修改密码
                  </div>
                  <div class="lke-l-top-1-r-but-in" @click="loginOut">退出</div>
                </div>
                <a class="lke-l-top-1-r-a" slot="reference">{{ userInfo.name }}<i class="el-icon-caret-bottom"></i></a>
              </el-popover>
              <!-- <div
                class="lke-l-top-1-r-but"
                style="background: #2890f4"
                @click="dialogVisible = true"
              >
                上传照片
              </div> -->
              <div class="lke-l-top-1-r-but" style="background: #fcb10c" @click="openRouter('xgxx')">
                查看信息
              </div>
            </div>
          </div>
          <username />
        </div>
        <div class="lke-l-fot">
          <div class="lke-l-fot-top">
            <h3>使用指南</h3>
          </div>
          <div class="lke-l-fot-fot">
            <div class="lke-l-tab" @click="openRouter('grzxIndex')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>中心首页</span>
              </div>
            </div>
            <div class="lke-l-tab" @click="openRouter('pxxz')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>操作手册</span>
              </div>
            </div>
            <div class="lke-l-tab" @click="openRouter('courseAssess')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>课程评估</span>
              </div>
            </div>
          </div>
          <div class="lke-l-fot-top" v-if="
            roles === 'notEnrolled' ||
            roles === 'headquarters' ||
            roles === 'nonHeadquarters'
          ">
            <h3>个人管理</h3>
          </div>
          <div class="lke-l-fot-fot" v-if="
            roles === 'notEnrolled' ||
            roles === 'headquarters' ||
            roles === 'nonHeadquarters'
          ">
            <div class="lke-l-tab" v-if="roles === 'notEnrolled'" @click="openRouter('bmdj')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>报名登记</span>
              </div>
            </div>
            <div class="lke-l-tab" v-if="roles === 'headquarters'" @click="openRouter('xjgl')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>信息管理</span>
              </div>
            </div>
            <div class="lke-l-tab" v-if="roles !== 'notEnrolled'" @click="openRouter('zssq')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>申请证书</span>
              </div>
            </div>
          </div>
          <!-- <div class="lke-l-fot-top">
            <h3>学员交流</h3>
          </div>
          <div class="lke-l-fot-fot">
            <div
              class="lke-l-tab"
              v-if="
                roles === 'certificate' ||
                roles === 'headquarters' ||
                roles === 'nonHeadquarters'
              "
              @click="openRouter('xydt')"
            >
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>学院动态</span>
              </div>
            </div>
            <div class="lke-l-tab" @click="openRouter('StudentAction')">
              <div class="lke-l-tab-in">
                <i class="el-icon-s-shop"></i>
                <span>通知</span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="lke-in-r">
        <router-view />
      </div>
    </div>

    <el-dialog title="上传" :visible.sync="dialogVisible" width="250px">
      <el-upload class="avatar-uploader" action="http://192.168.0.100:7005/api/v1/file" :show-file-list="false"
        :headers="headers" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <img v-if="imageUrl" :src="url + imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div style="text-align: center">尺寸为180*250</div>
    </el-dialog>
  </div>
</template>

<script>
import { changeuserinfo } from "@/api/index";
import { getToken, getImgUrl, removeToken } from "@/utils/auth";
import username from "./components/username";
export default {
  props: {},
  data() {
    return {
      url: "@/pages/index/assets/bird.jpeg",
      visible: false,
      dialogVisible: false,
      imageUrl: "",
      url: getImgUrl(),
      headers: { Authorization: getToken() },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    roles() {
      return this.$store.state.roles;
    },
  },
  created() { },
  mounted() { },
  watch: {},
  methods: {
    loginOut() {
      this.$store.commit("userInfo", false);
      removeToken();
      this.$router.push({ name: "login" });
    },

    openRouter(val) {
      this.$router.push({ name: val });
    },

    handleAvatarSuccess(res, file) {
      let obj = {
        student: {
          avatar: res.patch,
        },
      };
      changeuserinfo(obj).then((response) => {

        this.imageUrl = response.avatar;
        this.$store.commit("userInfo", response);
      });
      // this.imageUrl = URL.createObjectURL(file.raw);
    },

    async beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const status = await this.isSize(file);
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      if (!status) {
        this.$message.error("上传图片尺寸为250*180");
      }
      return isJPG && isLt2M && status;
    },

    isSize(file) {
      return new Promise((res, rej) => {
        var img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = function () {
          var width = img.width;
          var height = img.height;
          var filesize = img;
          if (width != 180 || height != 250) {
            res(false);
          } else {
            res(true);
          }
        };
      });
    },
  },
  components: {
    username,
  },
};
</script>

<style>
.el-popover {
  min-width: 90px;
  padding: 0;
}
</style>

<style scoped>
::v-deep.avatar-uploader {
  margin: 0 auto;
  width: 180px;
}

::v-deep.avatar-uploader .el-upload {
  margin: 0 auto;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 250px;
  line-height: 250px;
  text-align: center;
}

::v-deep.avatar {
  width: 178px;
  height: 250px;
  display: block;
}

::v-deep.lke-bg {
  background: #eeeeee;
}

.lke-avatar {
  font-size: 14px;
  text-align: center;
  line-height: 120px;
  color: #888888;
}

.lke-bg-in {
  width: 1024px;
  margin: 0 auto;
  background: #fff;
  display: flex;
}

.lke-in-l {
  background: #f7f7f7;
  padding: 20px 0 20px 30px;
  height: 100%;
}

.lke-l-top {
  padding: 0 15px 25px 0;
}

.lke-l-top-1 {
  display: flex;
}

.lke-l-top-1-r {
  padding-left: 15px;
  flex: 1;
}

.lke-l-top-1-r-p {
  font-size: 16px;
  font-weight: bold;
  line-height: 150%;
  margin-top: 10px;
  margin-bottom: 5px;
}

.lke-l-top-1-r-a {
  text-align: center;
  margin-top: 5px;
  font-size: 14px;
  color: #008ace;
  cursor: pointer;
}

.lke-l-top-1-r-but {
  padding: 3px 15px;
  text-align: center;
  font-size: 14px;
  background: #ccc;
  margin-top: 5px;
  cursor: pointer;
  color: #fff;
}

.lke-l-top-1-r-but-in {
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}

.lke-l-top-1-r-but-in:hover {
  background: #ccc;
}

.lke-l-fot-top {
  background: #2890f4;
  padding: 8px 0 8px 20px;
  margin-bottom: 5px;
}

.lke-l-fot-top>h3 {
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: bold;
}

.lke-l-fot-fot {
  margin-bottom: 20px;
}

.lke-l-tab {
  background: #ededed;
  margin-bottom: 5px;
  padding-left: 8px;
  border: 1px solid #ededed;
  border-right: none;
  cursor: pointer;
}

.lke-l-tab-in {
  padding: 1px 0 1px 30px;
  display: flex;
  align-items: center;
}

.lke-l-tab-in>i {
  padding-right: 10px;
  font-size: 28px;
  color: #2890f4;
}

.lke-l-tab-in>span {
  font-size: 14px;
  line-height: 28px;
  color: #494747;
}

.lke-l-tab:hover {
  background: #2890f4;
  border-color: #ccc;
}

.lke-l-tab:hover>.lke-l-tab-in {
  background: #fff;
}

.lke-in-r {
  flex: 1;
  padding: 20px;
  box-shadow: -1px 0 3px rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/grzx.vue